<template>
	<div>
		<div class="flex items-center border border-primary mt-4">
			<input class="placeholder-primary appearance-none bg-transparent border-none w-full text-primary mr-3 py-1 px-2 leading-tight focus:outline-none" name="email" type="email" v-model="email" v-validate="{ required: true , email:true }" :placeholder="t('email')" aria-label="Email">
			<button class="flex-shrink-0 bg-secondary-300 text-sm text-white py-2 px-4 rtl:border-r" type="submit" @click="SubmitForm">
				{{ t('send')}}
			</button>
		</div>
		<p v-show="errors.has('email')" class="text-red-500 text-xs mt-3">{{ errors.first('email') }}</p>
	</div>
</template>
<script>
	import axios from 'axios';
	import arabic from 'vee-validate/dist/locale/ar';
	import { Validator , mapFields} from 'vee-validate';
	export default {
		name: "Newsletter",
		props: {
			action: {
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
		},
		data() {
			return {
				email:''
			};
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		created() {
			this.$validator.localize('ar', {
				messages: arabic.messages,
				attributes: this.translate.ar,
				custom:this.translate.ar.custom
			});
			this.$validator.localize('en', {
				custom:this.translate.en
			});
			Validator.localize(this.sitelocale);
		},
		methods: {
			SubmitForm(){
				this.$validator.validateAll().then((result) => {
					if (result) {
						const action = this.action;
						axios.post(action, {'email':this.email})
								.then( response => {
									this.$toasted.success(response.data.message);
									this.email ='';
									this.success = true;
								})
								.catch(error => {
									let toaster = this.$toasted;
									$.each(error.response.data.errors, function(key, value) {
										toaster.error(value.message);
									});
									this.success = false;

								})
								.then(()=>{
									this.submitting = false;
									setTimeout(()=>{
										this.success = false;
									}, 3500);
								});

					}

				});

			},
		},

	};
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/Newsletter.vue